import permission from "@/middlewares/permission";


function loadView( view ) {
    return () => import(`@/views/admin/nrk/${ view }.vue`);
}


const Index = loadView( 'Index' );

const demoRoutes = [

    {
        path: 'demo',
        name: 'api.demo.resource.getList',
        component: Index,
        meta: {
            middleware: permission
        }
    }
];
export default demoRoutes;
